export default __webpack_public_path__ + "static/media/jcb.b9d18762.svg";